<template>
  <bg-style v-if="enabled" class="quen-unlock-widget" :is-disabled="$store.getters.isStandAloneMode" :class="{ 'is-mobile': $store.getters.isMobile }" :bg="model.background">
    <module-block :bg="model.background" class="quen-unlock-widget-content">
      <div v-if="model.titleVisible" class="title">
        <rich-text v-model="model.title" :editing="editing" :disabled="!editing"
          class="w-full" placement="bottom" theme="snow" />
      </div>
      <div v-if="model.subtitleVisible" class="describe mt-[8px]">
        <rich-text v-model="model.subtitle" :editing="editing" :disabled="!editing"
          class="w-full" placement="bottom" theme="snow" />
      </div>
      <div v-if="stopCountdownTimer" class="stop-countdown relative flex items-center justify-end pr-[2px]" :style="getTextColor(model.textColor)">
        <i class="el-icon-timer" />
        <span class="ml-1">{{ stopCountdownDays }}d:{{ stopCountdownHours }}:{{ stopCountdownMinutes }}:{{ stopCountdownSeconds }}</span>
      </div>
      <reward-flow v-imloading="loading" :model="model" :editing="editing" :steps="steps" :cols="model?.cols || 4"
        @close-pay="getActivityDetail" />
    </module-block>
  </bg-style>
</template>

<script>
import { Message } from 'element-ui'
import countdownMixins from '~/mixins/countdownMixins';
import cloneDeep from 'lodash/cloneDeep'
import ModuleBlock from '~/components/common/ModuleBlock.vue';
import { QuenUnlockStatusEnum } from '~/enums/data';
import Bus from "~/site/model/bus";
import tools, { getTextColor } from '~/utils'
import RewardFlow from '~/site/widgets/quenUnlockWidget/components/RewardFlow.vue'
import RichText from "~/components/richText/index.vue"

export default {
  mixins: [countdownMixins],
  components: {
    RewardFlow,
    ModuleBlock,
    RichText,
    countdownMixins
  },
  props: {
    model: { type: Object, default: () => ({}) },
    editing: { type: Boolean, default: false },
    device: { type: String, default: '' }
  },
  data() {
    return {
      steps: [],
      enabled: false,
      loading: false
    }
  },
  computed: {
    bizId() {
      return this.model?.bizId
    },
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    },
    ipInfo() {
      return tools.getLangByip(this)
    }
  },
  watch: {
    bizId() {
      this.getActivityDetail()
    }
  },
  beforeDestroy() {
    Bus.$off('reloadActivity')
  },
  mounted() {
    this.init()
  },
  methods: {
    getTextColor,
    init() {
      Bus.$on('reloadActivity', () => {
        this.getActivityDetail()
      })
      this.getActivityDetail()
    },
    getStatusName(data) {
      if ([2, 3].includes(data.status) && !data.is_free) {
        return QuenUnlockStatusEnum.Priced
      } else if (data.status === 3 && data.is_free) {
        return QuenUnlockStatusEnum.Free
      } else if (data.status === 2 && data.is_free) {
        return QuenUnlockStatusEnum.Free
      } else if (data.status === 1 && !data.is_free) {
        return QuenUnlockStatusEnum.Purchased
      } else if (data.status === 1 && data.is_free) {
        return QuenUnlockStatusEnum.Claimed
      }
    },
    activityUnusual() {
      if (this.editing) {
        this.enabled = true
        this.steps = cloneDeep(this.model.__mockData)
      } else {
        this.enabled = false
        this.model.__hide = true
      }
    },
    async getActivityDetail() {
      if (!this.bizId) {
        this.activityUnusual()
        return
      }
      const params = {
        project_id: this.$store.getters.projectId,
        activity_id: this.bizId,
        site_id: this.$store.state.project.info.id
      }
      this.loading = true
      const [err, res] = await this.$utils.to(this.$api.activity.getQuenUnlocDetail(params, this.editing))
      this.loading = false
      if (err) {
        Message.error(err)
      } else {
        const levels = res.levels || []
        const that = this
        that.enabled = this.editing || res.in_progress
        this.model.__hide = !res.in_progress
        this.steps = levels.map((item) => {
          const free = item.is_free
          const product = cloneDeep(item.product)
          const newItem = {
            free,
            id: item.id,
            status_name: this.getStatusName(item),
            status: item.status
          }
          if (!free) {
            newItem.goods = {
              ...product,
              priceInfo: tools.getPriceInfo(product.price_setting, that.ipInfo, that)
            }
          } else {
            newItem.gifts = item.gifts
          }
          return newItem
        })
        this.stopCountDown(res.stop_time * 1000)
      }
    }
  }
}
</script>

<style lang="less">
.quen-unlock-widget {
  padding: 20px 0;

  .describe {
    margin-bottom: 40px;
  }

  .stop-countdown {
    font-size: 18px;
    margin-bottom: 20px;
  }

  &.is-mobile {
    padding: 10px;
    .stop-countdown {
      font-size: 14px;
      margin-bottom: 10px;
    }
    .describe {
      margin-bottom: 20px;
    }
  }
}
</style>